import useIsRTL from './useIsRTL';

export default useIsRTL;